// extracted by mini-css-extract-plugin
module.exports = {"waiting":"waiting-2Vbdu","icon":"icon-3Qm8i"};